import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgEmptyUrl from '@/assets/misc/img_empty.svg'
import LookingEmptyIllustration from '@/components/SpotIllustration/LookingEmptyIllustration'

interface NoResultsEmptyStateProps {
  /**
   * Whether a search filter is applied or not.
   */
  isSearchFilterApplied: boolean
  /**
   * Callback for clearing the search filter.
   */
  onClearSearchFilter: () => void
  /**
   * Hides the illustration, for workspaces in corporate mode.
   */
  corporateMode: boolean
  /**
   * The title when nothing matched without a search filter.
   */
  title?: string
}

/**
 * Placeholder for a searchable list that came back empty.
 */
export function NoResultsEmptyState({
  isSearchFilterApplied,
  onClearSearchFilter,
  corporateMode,
  title = 'No results found',
}: NoResultsEmptyStateProps) {
  return (
    <EmptyState size="sm" grow>
      {!corporateMode && (
        <EmptyStateIllustration
          src={imgEmptyUrl}
          illustration={byDesign(undefined, LookingEmptyIllustration)}
        />
      )}
      {isSearchFilterApplied ? (
        <>
          <EmptyStateTitle>
            We couldn't find what you were looking for.
          </EmptyStateTitle>
          <EmptyStateDescription>
            Maybe try{' '}
            <Button
              label="clearing your search filter"
              variant="text"
              size="baseline"
              onPress={onClearSearchFilter}
            />{' '}
            ?
          </EmptyStateDescription>
        </>
      ) : (
        <EmptyStateTitle>{title}</EmptyStateTitle>
      )}
    </EmptyState>
  )
}
